// extracted by mini-css-extract-plugin
export default {"modalOverlay":"TJ-z","modalContent":"UJ-z","header":"VJ-z","close":"WJ-z"};